import { DynamicPageProps } from '@doltech/routeDefinition';
import { PageTypeEnum } from '@doltech/utils/lib/constants';
import { getLandingUrlFromPath } from '@doltech/utils/lib/url';
import * as React from 'react';
import { Route } from 'antd/lib/breadcrumb/Breadcrumb';

import {
  bannerHomePage,
  bannerOnlineTest,
  bannerSpeakingSample,
  bannerWritingSample,
} from './bannerImages';

export interface PageObjectContentModel {
  title?: string;
  description?: string;
  url?: string;
  readMoreText?: string;
  relatedPostsTitle?: string;

  banner: any;
  bannerLink: string;
  routes?: Route[];
}

export const usePageObjectContent = (
  pageType: PageTypeEnum,
  internalPageLink?: DynamicPageProps['internalPageLink']
) => {
  return React.useMemo((): PageObjectContentModel => {
    switch (pageType) {
      case PageTypeEnum.READING_IELTS_BLOG:
        return {
          title: 'IELTS Reading',
          description:
            'Chứa lý thuyết hướng dẫn học IELTS Reading Tư Duy và phần luyện tập kèm giải thích chi tiết',
          url: getLandingUrlFromPath(
            internalPageLink?.staticPageLink.LANDING_READING_IELTS_BLOG?.url,
            'landing-blog'
          ),
          readMoreText: 'Đọc thêm từ IELTS Reading',
          banner: bannerOnlineTest,
          bannerLink: internalPageLink?.staticPageLink?.LANDING_FULL_TEST?.url || '/',
        };
      case PageTypeEnum.LISTENING_IELTS_BLOG:
        return {
          title: 'IELTS Listening',
          description:
            'Chứa lý thuyết hướng dẫn học IELTS Listening Tư Duy và phần luyện tập kèm giải thích chi tiết',
          url: getLandingUrlFromPath(
            internalPageLink?.staticPageLink.LANDING_LISTENING_IELTS_BLOG?.url,
            'landing-blog'
          ),
          readMoreText: 'Đọc thêm từ IELTS Listening',
          banner: bannerOnlineTest,
          bannerLink: internalPageLink?.staticPageLink?.LANDING_FULL_TEST?.url || '/',
        };
      case PageTypeEnum.SPEAKING_IELTS_BLOG:
        return {
          title: 'IELTS Speaking',
          description:
            'Chứa lý thuyết hướng dẫn học IELTS Speaking Tư Duy và kho bài mẫu 8.0+ cập nhật hàng tuần',
          url: getLandingUrlFromPath(
            internalPageLink?.staticPageLink.LANDING_SPEAKING_IELTS_BLOG?.url,
            'landing-blog'
          ),
          readMoreText: 'Đọc thêm từ IELTS Speaking',
          banner: bannerSpeakingSample,
          bannerLink: internalPageLink?.staticPageLink?.LANDING_SPEAKING_SAMPLE?.url || '/',
        };
      case PageTypeEnum.WRITING_IELTS_BLOG:
        return {
          title: 'IELTS Writing',
          description:
            'Chứa lý thuyết hướng dẫn học IELTS Writing Tư Duy và kho bài mẫu 8.0+ cập nhật hàng tuần',
          url: getLandingUrlFromPath(
            internalPageLink?.staticPageLink.LANDING_WRITING_IELTS_BLOG?.url,
            'landing-blog'
          ),
          readMoreText: 'Đọc thêm từ IELTS Writing',
          banner: bannerWritingSample,
          bannerLink: internalPageLink?.staticPageLink?.LANDING_WRITING_SAMPLE?.url || '/',
        };
      case PageTypeEnum.BOOK_REVIEW_IELTS_BLOG:
        return {
          title: 'Review Sách & Tài Liệu IELTS',
          description: 'Review và tải sách và các tài liệu học IELTS',
          url: getLandingUrlFromPath(
            internalPageLink?.staticPageLink.LANDING_BOOK_REVIEW?.url,
            'landing-blog'
          ),
          readMoreText: 'Đọc thêm từ Review Sách & Tài Liệu IELTS',
          banner: bannerHomePage,
          bannerLink: internalPageLink?.staticPageLink?.LANDING_HOME?.url || '/',
        };
      case PageTypeEnum.TEACHER_REVIEW_IELTS_BLOG:
      case PageTypeEnum.COURSE_REVIEW_IELTS_BLOG:
      case PageTypeEnum.CENTER_REVIEW_IELTS_BLOG:
        return {
          title: 'IELTS Center & Teacher Review',
          description: 'Review trung tâm, giáo viên, khoá học IELTS ở Việt Nam khách quan',
          url: getLandingUrlFromPath(
            internalPageLink?.staticPageLink.LANDING_CENTER_REVIEW?.url,
            'landing-blog'
          ),
          readMoreText: 'Đọc thêm từ IELTS Center & Teacher Review',
          banner: bannerHomePage,
          bannerLink: internalPageLink?.staticPageLink?.LANDING_HOME?.url || '/',
        };
      case PageTypeEnum.IELTS_INFO_BLOG:
        return {
          title: 'Tổng Quan về IELTS',
          description:
            'Gồm hướng dẫn tự học, review sách & tài liệu, và review trung tâm & giáo viên.',
          url: getLandingUrlFromPath(
            internalPageLink?.staticPageLink.LANDING_IELTS_REVIEW?.url,
            'landing-blog'
          ),
          readMoreText: 'Đọc thêm từ Tổng quan về IELTS',
          banner: bannerHomePage,
          bannerLink: internalPageLink?.staticPageLink?.LANDING_HOME?.url || '/',
        };
      case PageTypeEnum.VOCAB_IELTS_BLOG:
        return {
          title: 'Từ Vựng IELTS',
          description: 'Chứa danh sách các chủ đề từ vựng IELTS phổ biến cho cả 4 skills',
          url: getLandingUrlFromPath(
            internalPageLink?.staticPageLink.LANDING_VOCAB_IELTS_BLOG?.url,
            'landing-blog'
          ),
          readMoreText: 'Đọc thêm từ Từ Vựng',
          banner: bannerHomePage,
          bannerLink: internalPageLink?.staticPageLink?.LANDING_HOME?.url || '/',
        };
      case PageTypeEnum.GRAMMAR_IELTS_BLOG:
        return {
          title: 'Ngữ pháp IELTS',
          description: 'Chứa các điểm ngữ pháp quan trọng và chắt lọc cho kỳ thi IELTS',
          url: getLandingUrlFromPath(
            internalPageLink?.staticPageLink.LANDING_GRAMMAR_IELTS_BLOG?.url,
            'landing-blog'
          ),
          readMoreText: 'Đọc thêm từ Ngữ pháp',
          banner: bannerHomePage,
          bannerLink: internalPageLink?.staticPageLink?.LANDING_HOME?.url || '/',
        };
      case PageTypeEnum.DOL_NEWS_IELTS_BLOG: {
        const title = 'Tin tức về DOL';
        const url = getLandingUrlFromPath('/tin-tuc-ve-dol');
        return {
          title,
          description: 'Tin tức mới nhất về các hoạt động và sự kiện mà DOL tham dự',
          url,
          readMoreText: 'Đọc thêm từ Tin tức',
          banner: bannerHomePage,
          bannerLink: '/',
          relatedPostsTitle: 'Tin tức khác',
          routes: [
            {
              path: '/',
              breadcrumbName: 'Trang chủ',
            },
            {
              breadcrumbName: title,
              path: url,
            },
          ],
        };
      }
      case PageTypeEnum.DOL_LINEAR_IELTS_BLOG: {
        const title = 'Linearthinking';
        const url = getLandingUrlFromPath('/gioi-thieu-linearthinking');
        return {
          title,
          description:
            'Giới thiệu về phương pháp học Tiếng Anh Tư Duy cho 4 kỹ năng và phần từ vựng, ngữ pháp',
          url,
          readMoreText: 'Đọc thêm',
          banner: bannerHomePage,
          bannerLink: '/',
          relatedPostsTitle: 'Bài viết khác',
          routes: [
            {
              path: '/',
              breadcrumbName: 'Trang chủ',
            },
            {
              breadcrumbName: title,
              path: url,
            },
          ],
        };
      }
      case PageTypeEnum.STUDENT_STORY_IELTS_BLOG: {
        const title = 'Thành tích và cảm nhận của học viên';
        const url = getLandingUrlFromPath('/hall-of-fame');
        return {
          title,
          description: 'Gồm review của học viên, thành tích và câu chuyện của học viên ở DOL.',
          url,
          readMoreText: 'Đọc thêm từ Thành tích và cảm nhận',
          banner: bannerHomePage,
          bannerLink: '/',
          relatedPostsTitle: 'Câu chuyện khác',
          routes: [
            {
              path: '/',
              breadcrumbName: 'Trang chủ',
            },
            {
              breadcrumbName: title,
              path: url,
            },
          ],
        };
      }
    }
    return null;
  }, [internalPageLink, pageType]);
};
